import React, { useEffect, useReducer } from "react";
import * as notify from "../../../../shared/notify";
import { useParams } from "react-router-dom";

import TaskNav from "../../../task-nav/task-nav";
import DrugPanel from "./components/drug-panel";
import PanelTabs from "../panel-tab";

import { reducer, initialState } from "./reducer";
import { useKeyboardShortcut } from "../../../../shared/hooks/hotkeys";
import { sendSingleAttributeData } from "../../lib/attribute-data";
import { validatePanel } from "./lib/validation";

import "./drug.scss";

const DrugIndex = (props) => {
    const params = useParams();
    const [state, dispatch] = useReducer(reducer, initialState);
    const hotkeys = useKeyboardShortcut();
    const taskId = params.id;

    useEffect(() => {
        dispatch({ type: "SAVE_PANELS", panels: props.value.panels || [], isDirty: false });
    }, []);

    useEffect(() => {
        switch (hotkeys) {
            case "SAVE":
                savePanel();
                break;
            default:
                break;
        }
    }, [hotkeys]);

    const changeTab = (tabIndex) => {
        dispatch({ type: "SET_PANEL_INDEX", selectedPanel: tabIndex });
    };

    const addPanel = () => {
        dispatch({ type: "ADD_PANEL" });
    };

    const removePanel = async () => {
        const verify = await notify.confirm(`Are you sure you want to delete Panel ${state.selectedPanel + 1}?`);

        if (verify) {
            dispatch({ type: "REMOVE_PANEL" });
        }
    };

    const updateState = (key, value) => {
        dispatch({ type: "UPDATE_STATE", key: key, value: value });
    };

    const addItem = (key, value) => {
        dispatch({ type: "ADD_ITEM", key: key, value: value });
    };
    const updateItem = (section, value) => {
        dispatch({ type: "UPDATE_ITEM", section: section, value: value });
    };

    const removeItem = (section, key) => {
        dispatch({ type: "REMOVE_ITEM", section: section, key: key });
    };

    const savePanel = async () => {
        // Validation
        if (!validatePanel(state.panels)) {
            return false;
        }

        try {
            if (!props.skipInternalSave) {
                const response = await sendSingleAttributeData(props.codingWipKey, taskId, props.sourcePage, {
                    definition: props.attribute.uuid,
                    type: props.attribute.componentType,
                    value: { panels: state.panels },
                });

                if (!response) {
                    return false;
                }

                notify.success("Saved");
            }

            props.updateOnChange(props.attribute.uuid, { panels: state.panels }, props.attribute.componentType);
            dispatch({ type: "SET_DIRTY_FLAG", isDirty: false });

            return true;
        } catch (err) {
            notify.error(err);

            return false;
        }
    };

    const closePanel = async () => {
        if (state.isDirty) {
            const confirm = await notify.confirm("You have unsaved data.  Are you sure you want to navigate away? Unsaved data will be lost!");

            if (!confirm) {
                return;
            }
        }

        props.closeModal();
    };

    const panel =
        state.panels.length > 0 ? (
            <DrugPanel
                key={`panel${state.selectedPanel}of${state.panels.length}`}
                panel={state.panels[state.selectedPanel]}
                selectedIndex={state.selectedPanel}
                removePanel={removePanel}
                updateState={updateState}
                addNewItem={addItem}
                removeItem={removeItem}
                updateItem={updateItem}
            />
        ) : null;

    return (
        <div className="container">
            <TaskNav>
                <div className="button-group">
                    <button className="button" onClick={closePanel}>
                        Back
                    </button>
                    <h1 className="txt-center">Drug Facts</h1>
                    <button className="button -primary" onClick={savePanel}>
                        Save
                    </button>
                </div>
            </TaskNav>
            <PanelTabs tabs={state.panels} addTab={addPanel} changeTab={changeTab} selectedIndex={state.selectedPanel} />
            {panel}
        </div>
    );
};

export default DrugIndex;
